import { qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import { backgroundVideoHandler } from "@/lib/a11y";
import videoPlayerBlock from "@/lib/video-player-block";
import { animateStandard, shouldAnimate } from "@/lib/animation";
import autoPlay from "../lib/autoPlay";

const selectors = {
  video: ".video-hero__video",
  videoPlayerVideo: "[data-video-player-block-video]",
  videoPlayerBlock: ".video-player-block",
};

section("video-hero", {
  videoHandler: null,
  onLoad() {
    const videoPlayerVideos = qsa(selectors.videoPlayerVideo, this.container);
    const video = qsa(selectors.video, this.container);

    if (videoPlayerVideos.length) {
      this.videoPlayers = videoPlayerVideos.map(block =>
        videoPlayerBlock(block.closest(selectors.videoPlayerBlock))
      );
    }

    if (video) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(video);
    }

    if (shouldAnimate(this.container)) {
      this.animateVideoHero = animateStandard(this.container, 3);
    }
  },

  onUnload() {
    this.videoPlayers && this.videoPlayers.forEach(button => button.unload());
    this.videoHandler && this.videoHandler();
    this.animateVideoHero?.destroy();
  },
});
